import { Sparkle } from "@phosphor-icons/react";

/**
 * Consistent, warm page header for all inner pages (admin + client).
 * Example:
 *   <PageHeader
 *     eyebrow="Clienti"
 *     title="I tuoi clienti"
 *     subtitle="Gestisci wallet, listini e stato di ogni brand"
 *     chip="tf-chip-lavender"
 *     icon={Users}
 *     actions={<button>...</button>}
 *   />
 */
export default function PageHeader({
  eyebrow,
  title,
  subtitle,
  chip,
  icon: Icon,
  actions,
}) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div className="flex items-start gap-4">
        {Icon && chip && (
          <div className={`tf-chip ${chip}`} style={{ width: 56, height: 56, borderRadius: 18 }}>
            <Icon size={26} weight="fill" />
          </div>
        )}
        <div>
          {eyebrow && (
            <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-[var(--tf-muted)]">
              <Sparkle size={12} weight="fill" /> {eyebrow}
            </div>
          )}
          <h1 className="font-display font-black text-3xl lg:text-4xl tracking-tight mt-2">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-[var(--tf-muted)] mt-1.5 max-w-2xl">{subtitle}</p>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
